export enum CheckBookingStatus {
  SUCCESS,
  NAME_DOES_NOT_MATCH,
  BAD_BOOKING_CODE,
  BOOKING_NOT_FOUND,
  BOOKING_IN_THE_PAST,
  ALREADY_ADDED,
  ALREADY_ADDED_TO_OTHER_ACCOUNT,
  UNEXPECTED_STRING_RESPONSE,
  GENERAL_ERROR,
}
